import { Role } from "../../types/role";

const VESMun: Role = {
  primary: [
    "Passen",
    "Tackling",
    "Einsatzfreude",
    "OhneBall",
    "Teamwork",
    "Ausdauer",
  ],
  secondary: [
    "Abschluss",
    "Ballannahme",
    "Dribbling",
    "Technik",
    "Weitschuesse",
    "Aggressivitaet",
    "Antizipation",
    "Entscheidungen",
    "Nervenstaerke",
    "Stellungsspiel",
    "Antritt",
    "Balance",
    "Kraft",
    "Schnelligkeit",
  ],
  physis: "mittelfeld",
};

export const VESM = {
  VESMun,
};
